import {
  ROOT_PATH,
  ADMIN_ROOT_PATH_MOBILE,
  ACTIVITY_REPORT_PATH_MOBILE,
  APPLY_ACTIVITY_PATH_MOBILE,
  ENTITIES_AND_USERS_PATH_MOBILE
} from 'routes/paths'
import type { UserState } from 'utils/hooks/use-userInfo'
import type { LocationType } from '../types'

function getRedirectLocation(user: UserState, currentPath): LocationType {
  const adminMobilePaths = [
    ADMIN_ROOT_PATH_MOBILE,
    ACTIVITY_REPORT_PATH_MOBILE,
    APPLY_ACTIVITY_PATH_MOBILE,
    ENTITIES_AND_USERS_PATH_MOBILE
  ]

  if (!user.isTeacher && adminMobilePaths.includes(currentPath)) {
    return { pathname: ROOT_PATH }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
